// extracted by mini-css-extract-plugin
export default {"fade-out":"FooterHorizontal_fade-out__0qS+t"};